<template lang="pug">
  //section#instacart-video.video
    .video-wrapper
      .video-poster(v-lazy:background-image.container="imgVideo")
        .video-poster__icon
          h3 Hear from our partner Amanda Kloots about why Instacart shoppers hold a special place in her heart. 
          svg(id="play-video"  viewBox="0 0 163 163" @click="playVideo")
            g(fill="none")
              g(transform="translate(2.000000, 2.000000)" stroke-width="4")
                path(id="lineOne" d="M10,80 C10,118.107648 40.8923523,149 79,149 L79,149 C117.107648,149 148,118.107648 148,80 C148,41.8923523 117.107648,11 79,11")
                path(id="triangle" d="M105.9,74.4158594 L67.2,44.2158594 C63.5,41.3158594 58,43.9158594 58,48.7158594 L58,109.015859 C58,113.715859 63.4,116.415859 67.2,113.515859 L105.9,83.3158594 C108.8,81.1158594 108.8,76.6158594 105.9,74.4158594 L105.9,74.4158594 Z" )
                path(id="lineTwo" d="M159,79.5 C159,35.5933624 123.406638,0 79.5,0 C35.5933624,0 0,35.5933624 0,79.5 C0,123.406638 35.5933624,159 79.5,159 L79.5,159")
      youtube(:video-id="videoId" ref="youtube" @playing="playing")
  section#instacart-video.video
    .video-inner
      .video-content
        .video-inner__image
          img(v-lazy="imgUrl" alt="" width="300" height="399")
        .video-inner__text
          .video-inner__content-text
            h4 "Thanks to the incredible community of <span>Instacart shoppers"</span> 
              #lottie-video.lottie-anim
            p "I’m honored to join Instacart for <i>Beyond the Cart: A Year of Essential Stories</i> to pay tribute to Instacart shoppers who have helped so many families through the past year.
            p Since the early days of the pandemic, I’ve been vigilant about limiting my exposure and staying safe for my young son Elvis. Thanks to the incredible community of Instacart shoppers, I haven’t had to set foot in a grocery store in more than 12 months, which has given me so much peace of mind, especially as a single mom. As we all reflect on the past year, I’m proud to help raise awareness and appreciation for the essential role the Instacart shopper community has played, and will continue to play for so many people. Please join me in thanking them by reading and sharing their inspirational stories.”
            p <strong>Amanda Kloots</strong>,<br/> co-host of CBS’ The Talk

    
</template>
<script>
import { gsap } from 'gsap'
import lottie from 'lottie-web';
import img from '@/assets/images/instacart-video-cover.jpg';

export default{
  data: function () {
      return {
        videoId: 'R2opDNysGds',
        iframeSrc: 'https://www.youtube.com/embed/R2opDNysGds?rel=0&hd=1&showinfo=0&wmode=transparent&playsinline=1',
        clickedBanner: false,
        imgUrl: img
      }
  },
  components:{
    
  },
  mounted: function () {
    this.loadLottie();
  },
  methods: {
    loadLottie(){
      const animClapping = {
        container: document.getElementById('lottie-video'),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: 'clapping.json',
        // Path for production //
         // path: '/blog-nubank/wp-content/themes/nubankv2/quiz/animations/lamp.json'
      }
      lottie.loadAnimation(animClapping)
    },
    playVideo(){
      this.player.playVideo();
      gsap.to('.video-poster', 1,{alpha:0});
      gsap.to('.video-poster', 0,{display:"none"}, "1");
      // this.iframeSrc = this.iframeSrc + '&autoplay=1';
      // this.clickedBanner = true;
      //   if(document.querySelector('#instacart-video iframe').readyState == 'complete'){
      //     gsap.to('.video-poster', 1,{alpha:0});
      //     gsap.to('.video-poster', 0,{display:"none"}, "1");
      //   }  
    },
    playing() {
      console.log('we are watching!!!')
    }
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    }
  }
}
</script>
<style lang="scss">
  .video{
    position: relative;
    display: block;
    width: 100vw;
    height: auto;
    overflow: hidden;
    /* min-height: 100vh; */
    background: $white;
    @include respond-to('mobile'){
      //min-height: inherit;
    }
    &-poster{
      position: absolute;
      padding: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: 2;
      //background-image: url("~@/assets/images/poster.png");
      background-position: center;
      background-size: cover;
      display: flex;
      justify-content: center;
      align-items: center;
      &__icon{
        padding: 1rem;
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        width: 750px;
        h3{
          color: $white;
          font-weight: 900;
          font-size: 1.6rem;
          text-align: center;
          @include respond-to('small'){
            font-size: 2.6rem;
          }
        }
        svg{
          stroke: $soft_green;
          width:100px;
          margin: 0 auto;
          display:block;
          cursor: pointer;
          transform-origin: 50% 50%;
          transform-origin: 50% 50%;
          overflow: inherit;    
          @include respond-to('mobile'){
            width: 130px;
          }
          @include respond-to('small'){
            width: 160px;
          }
          #lineOne, #lineTwo {
           transform-origin: 50% 50%;
           transition: 1s;
          } 
          &:hover{
            #triangle {
              fill:$soft_green;
              transform-origin: 50% 50%;
            }
            #lineOne {
              transform: rotate(260deg);
              -webkit-transform: rotate(260deg);
              -moz-transform: rotate(260deg);
              -o-transform: rotate(260deg);
              transform-origin: 50% 50%;
            } 
            #lineTwo {
              transform: rotate(-450deg);
               transform-origin: 50% 50%;
            } 
          }
          #triangle {
            fill:rgba(22,22,22,0);
            transition:500ms;
            transform-origin: 50% 50%;
          }
        }
        img{
          cursor: pointer;
        }
      }
    }
    &-wrapper{
      position: relative;
      height: 0;
      padding-top: 100%;
      @include respond-to('mobile'){
        padding-top: 56.48%;
      }
      iframe{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
    &-inner{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      width: 100%;
      /* min-height: 100vh; */
      position: relative;
      padding: 4rem 0;
      @include respond-to('small'){
        flex-flow: row;
        /* height: 100vh; */
        padding: 5rem 0;
      }
      &__image{
        position: relative;
        width: 300px;
        height: 400px;
        z-index: 2;
        margin: 0 auto;
        @include respond-to('small'){
          margin: -25px auto 0;
        }
        img{
          width: 100%;
          height: auto;
          object-fit: contain;
          border-radius: 30px;
          position: relative;
          border: 2px solid $orange;
        }
      }
      &__text{
        width: 100%;
        padding: 0;
        position: relative;
        height: auto;
        @include respond-to('small'){
          width: calc(100% - 330px);
          padding-left: 1rem;
          padding-right: 2rem;
          max-height: inherit;
          overflow: inherit;
        }
        &::before{
          content: '';
          position: absolute;
          top: -50px;
          right: 0;
          background: $soft_brown;
          width: 100%;
          height: calc(100% + 50px);
          border-radius: 25px;
          @include box-shadow(20px,20px,40px,rgba(0, 50, 36, 0.15), false);
          @include respond-to('small'){
            width: calc(100% + 165px);
            height: 100%;
            top: 0;
          }
        }
        h4{
          text-align: left;
          font-size: 1.2rem;
          font-weight: 900;
          color: $green;
          letter-spacing: 1px;
          span{
            color: $orange;
          }
          @include respond-to('small'){
            font-size: 2.2rem;
          }  
          img, #lottie-video{
            width: 45px;
            height: auto;
            display: inline-block;
            margin-top: 0px;
          }
        }
        p{
          margin: 1rem 0;
          color: $green;
          font-size: 1rem;
          line-height: 1.2;
          margin: 1rem 0;
          span{
            font-weight: normal;
          }
          &:last-child{
            margin-bottom: 2rem;
            @include respond-to('small'){
              margin-bottom: 0;
            }
          }
        }
      }
      &__content{
        &-text{
          position: relative;
          z-index: 2;
          padding: 1rem;
          @include respond-to('small'){
            padding: 2rem 0;
          }
        }
      }
    }
    &-content{
      max-width: 1200px;
      width: 100%;
      margin: 0 auto;
      border-radius: 20px;
      padding-top: 0;
      padding-bottom: 0.5rem;
      display: flex;
      flex-wrap: wrap;
      position: relative;
      padding: 0 1rem;
      @include respond-to('small'){
        padding: 0 2rem;
      }
    }
  }
</style>
